// extracted by mini-css-extract-plugin
export default {"label":"Upload_label__gl1M0","footer":"Upload_footer__5-mbA"};